import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataQq from './phonics/phonics_data_qq';

function PhonicsQq() {
  return <PhonicsAtoZ letterData={letterDataQq} />;
}

export default PhonicsQq;
